export default "__VITE_ASSET__CQ68aONj__"